import React, { useEffect, useCallback, useState} from 'react';
import {getBarWidth} from '../getBarWidth.js';
import {useScroll} from '../useScroll.js';
import TrackPattern from './TrackPattern.js';
import {connect} from 'react-redux';
import {
    PATTERN_SWITCH,
    SUB_SEQUENCE_VOLUME_CHANGE,
    SEQUENCE_ROLL,
    RESOLUTION_CHANGE} from 'session/constants.js';
import {DEFAULT_RESOLUTION} from '../constants.js';

const TrackPatterns = ({
    wrapperRef,
    events=[],
    track,
    subSequence,
    xScale,
    resolution,
    selectedEvents,
    isFrozen
}) => { 
    if (!selectedEvents ||
        Object.keys(selectedEvents).length === 0 ||
        selectedEvents[Object.keys(selectedEvents)[0]].patternNumber === undefined) {
        return [];
    }

    let event = selectedEvents[Object.keys(selectedEvents)[0]];
    if (!events.includes(event)) {
        return [];
    }
    let preWidth = getBarWidth(event.step, resolution, xScale);

    return (
        <div className="track-patterns">
          <div className="pattern-filler" style={{width: preWidth}}/>
          {[event].map(
              event =>
                  <TrackPattern
                    isFrozen={isFrozen}
                    key={event.id}
                    pattern={track.patterns[event.value % track.patterns.length]}
                    xScale={xScale}
                    resolution={resolution}
                    duration={event.duration}
                    track={track}
                    event={event}/>)}
        </div>);
}

const mapStateToProps = (state, props) => {
    let mixEvents = state.arrangement.mixEvents[props.subSequence.id];
    let patternSwitchEvents = mixEvents !== undefined ?
        mixEvents[PATTERN_SWITCH] : undefined;
    return {
        events: patternSwitchEvents,
        eventsLength: patternSwitchEvents === undefined ? 0 : patternSwitchEvents.length,
        patternDragging: state.sequencer.patternDragging,
        resolution: DEFAULT_RESOLUTION,
        automationTypeToShow: state.arrangement.automationTypeToShow[props.subSequence.id],
        xScale: state.arrangement.xScale,
        selectedEvents: state.arrangement.selectedEvents,
        isFrozen: props.track.isFrozen
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackPatterns);
